import { ElementRef, Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'

@Injectable()
export class ClickOutsideService {

  clickedElem$: BehaviorSubject<ElementRef>

  constructor() {
    this.clickedElem$ = new BehaviorSubject<ElementRef>(null)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/click-outside/click-outside.service.ts